import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
} from '@principle-theorem/practice-migrations/interfaces';
import { SourceEntity } from '../../../source/source-entity';
import { ADAItemSourceEntity, IPracticeWorksItemCode } from './ada-item';

export const ITEM_CODE_TRANSACTION_RESOURCE_TYPE = 'usedItemCodeTransactions';

export const ITEM_CODE_TRANSACTION_SOURCE_ENTITY = SourceEntity.init({
  metadata: {
    label: 'Item Codes Used as Transactions List',
    description: '',
    idPrefix: ITEM_CODE_TRANSACTION_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export type PracticeWorksTransactionItemCode =
  ISourceEntityTypes<IPracticeWorksItemCode>;

const ITEM_CODE_TRANSACTION_QUERY = `
SELECT
  tx_code_id AS id,
  tx_code_group_id AS group_id,
  user_id AS item_code,
  description
FROM
  _tx_code_defs_
WHERE medical_code IS NULL AND tx_code_id IS NOT NULL
`;

export class UsedItemCodeTransactionSourceEntity extends ADAItemSourceEntity {
  override sourceEntity = ITEM_CODE_TRANSACTION_SOURCE_ENTITY;
  override entityResourceType = ITEM_CODE_TRANSACTION_RESOURCE_TYPE;
  override sourceQuery = ITEM_CODE_TRANSACTION_QUERY;
}
